import { call, put, takeLatest, delay } from 'redux-saga/effects';
import { AGENCIES } from 'src/store/ActionTypes';
import * as api from 'src/store/api';

function* fetchAgencies(action) {
  try {
    const agencies = yield call(api.getAgencies, action.payload);
    yield put({
      type: AGENCIES.FETCH_AGENCIES_SUCCEEDED,
      payload: agencies,
    });
  } catch (e) {
    yield put({
      type: AGENCIES.FETCH_AGENCIES_FAILED,
      payload: e,
    });
  }
}

function* addAgency(action) {
  try {
    yield call(api.addAgency, action.payload);
    yield put({
      type: AGENCIES.ADD_AGENCY_SUCCEEDED,
    });
  } catch (e) {
    yield put({
      type: AGENCIES.ADD_AGENCY_FAILED,
      payload: e.message || e.toString(),
    });
  } finally {
    delay(500);
    yield put({
      type: AGENCIES.UNSET,
      payload: 'addAgencyStatus',
    });
  }
}

function* deleteAgency(action) {
  try {
    yield call(api.deleteAgency, action.payload);
    yield put({
      type: AGENCIES.DELETE_AGENCY_SUCCEEDED,
    });
    yield* fetchAgencies();
  } catch (e) {
    yield put({
      type: AGENCIES.DELETE_AGENCY_FAILED,
      payload: e,
    });
  } finally {
    delay(500);
    yield put({
      type: AGENCIES.UNSET,
      payload: 'deleteAgencyStatus',
    });
  }
}

function* fetchAgenciesSaga() {
  yield takeLatest(AGENCIES.FETCH_AGENCIES, fetchAgencies);
}

function* addAgencySaga() {
  yield takeLatest(AGENCIES.ADD_AGENCY, addAgency);
}

function* deleteAgencySaga() {
  yield takeLatest(AGENCIES.DELETE_AGENCY, deleteAgency);
}

export default [fetchAgenciesSaga(), addAgencySaga(), deleteAgencySaga()];
